import React from 'react';
import { Switch, Route } from 'react-router';
import PrerenderedLoadable from 'components/prerenderLoadable';
import './style.scss';

const SoccerDetailComponent = PrerenderedLoadable(() => import('../soccer/detail'));
const BaseballDetailComponent = PrerenderedLoadable(() => import('../baseball/detail'));
const BasketballDetailComponent = PrerenderedLoadable(() => import('../basketball/detail'));
const VolleyballDetailComponent = PrerenderedLoadable(() => import('../volleyball/detail'));
const HockeyDetailComponent = PrerenderedLoadable(() => import('../hockey/detail'));
const FootballDetailComponent = PrerenderedLoadable(() => import('../football/detail'));
const LolDetailComponent = PrerenderedLoadable(() => import('../lol/detail'));

// const StarcraftComponent = PrerenderedLoadable(() => import('./starcraft'));

const ScoreDetail = () => {
  return (
    <Switch>
      <Route path='/soccer/:id' component={SoccerDetailComponent} />
      <Route path='/baseball/:id' component={BaseballDetailComponent} />
      <Route path='/basketball/:id' component={BasketballDetailComponent} />
      <Route path='/volleyball/:id' component={VolleyballDetailComponent} />
      <Route path='/hockey/:id' component={HockeyDetailComponent} />
      <Route path='/football/:id' component={FootballDetailComponent} />
      <Route path='/lol/:id' component={LolDetailComponent} />

      {/*<Route path="/starcraft" component={StarcraftComponent} />*/}
    </Switch>
  );
};

export default ScoreDetail;
